import React from "react";
import BadRatings from "./views/Pages/Admin/BadRatings";
import BullMqJobs from "./views/Pages/Admin/BullMqJobs";
import { CustomFormat } from "./views/Pages/CustomFormat/CustomFormat";
import JobDataViewer from "./views/Pages/DataArchive/JobDataViewer";
import TransactionManager from "./views/Pages/DataArchive/TransactionManager/TransactionManager";
import { Invoices } from "./views/Pages/TagLevel/Invoices";
import { Transactions } from "./views/Pages/TagLevel/Transactions";
import { InvoiceViewer } from "./views/Pages/TagLevel/InvoiceViewer";
import { OnboardingWizard } from "./views/Pages/Surveys/Onboarding3";
import ExportForm from "./views/Pages/Form/ExportForm";
import { Forms } from "./views/Pages/TagLevel/Forms";
import { AutomaticDocs } from "./views/Pages/TagLevel/AutomaticDocs";
import { TemplateDocs } from "./views/Pages/TagLevel/TemplateDocs";

import { AssignJobsPage } from "./views/Pages/AssignJobs";
import { FraudData } from "./views/Pages/FraudViewer";
import { AnalyzeTabGated } from "./views/Pages/Analyze";
import WebhooksPage from "./views/Pages/Webhooks/WebhooksPage";
import ListWebhooks from "./views/Pages/Webhooks/ListWebhooks";
import CreateWebhook from "./views/Pages/Webhooks/CreateWebhook";
import WebhookDeliveries from "./views/Pages/Webhooks/WebhookDeliveries";
import { DrawRectangleV3Connected } from "./views/Pages/ExtractSingle/v2/DrawRectangleV3";
import ViewOtherDocuments from "./views/Pages/Tools/ViewOtherDocument";
import ReferralProgram from "./views/Pages/Account/Referrals/ReferralProgram";

const CustomTemplates = React.lazy(
  () => import("./views/Pages/Templates/CustomTemplates")
);

const ExtractSingle = React.lazy(() => import("./views/Pages/ExtractSingle"));
const NewTemplate = React.lazy(() => import("./views/Pages/NewTemplate"));
const NewTemplate2 = React.lazy(() => import("./views/Pages/NewTemplate2"));

const NewBankStatementTemplate = React.lazy(
  () => import("./views/Pages/NewBankStatementTemplate")
);
const NewTaxTemplate = React.lazy(() => import("./views/Pages/NewTaxTemplate"));

const UpdateTemplate = React.lazy(
  () => import("./views/Pages/UpdateTemplate/")
);

const ExtractTemplate = React.lazy(
  () => import("./views/Pages/ExtractTemplate")
);

const ExtractBankMode = React.lazy(
  () => import("./views/Pages/ExtractBankMode")
);

const ExtractInvoice = React.lazy(() => import("./views/Pages/ExtractInvoice"));
const InvoiceApprovalRulesPage = React.lazy(
  () => import("./views/Pages/Invoices/InvoiceApprovalRules")
);
const ExtractForm = React.lazy(() => import("./views/Pages/ExtractForm"));
const Csv2Qbo = React.lazy(() => import("./views/Pages/Csv2Qbo"));
const VendorsCsv = React.lazy(() => import("./views/Pages/VendorsCsv"));

const ExtractDataJobs = React.lazy(
  () => import("./views/Pages/DataArchive/ExtractDataJobs")
);
const CustomizableTemplates = React.lazy(
  () => import("./views/Pages/CustomizableTemplates")
);
const MyTemplates = React.lazy(() => import("./views/Pages/MyTemplates"));
const Integrations = React.lazy(() => import("./views/Pages/Integrations"));

const Account = React.lazy(() => import("./views/Pages/Account"));
const AccountNotifications = React.lazy(
  () => import("./views/Pages/Account/Notifications")
);
const Pricing = React.lazy(() => import("./views/Pages/Pricing"));
const RestartTrial = React.lazy(
  () => import("./views/Pages/Account/RestartTrial")
);

const Referrals = React.lazy(() => import("./views/Pages/Account/Referrals"));

const SeatManager = React.lazy(
  () => import("./views/Pages/Account/SeatManager/")
);

const AskForReview = React.lazy(
  () => import("./views/Pages/Review/AskForReview")
);
const ReviewIntuit = React.lazy(() => import("./views/Pages/Review/Intuit"));
const ReviewG2 = React.lazy(() => import("./views/Pages/Review/G2"));

const Tools = React.lazy(() => import("./views/Pages/Tools"));
const CustomDocument = React.lazy(
  () => import("./views/Pages/Tools/CustomDocument")
);

const UsersTable = React.lazy(() => import("./views/Pages/Admin/UsersTable"));
const Contracts = React.lazy(() => import("./views/Pages/Admin/Contracts"));

const UserExplorer = React.lazy(
  () => import("./views/Pages/Admin/UserExplorer")
);
const AdminDocumentExplorer = React.lazy(
  () => import("./views/Pages/Admin/AdminDocumentExplorer")
);
const Superlogin = React.lazy(() => import("./views/Pages/Admin/Superlogin2"));

const PgbossJobs = React.lazy(() => import("./views/Pages/Admin/Jobs"));
const AuditLog = React.lazy(() => import("./views/Pages/Admin/AuditLog"));

const QuickBooksAddNewCompany = React.lazy(
  () => import("./views/Pages/DataArchive/QuickBooksAddNewCompany")
);
const BankStatements = React.lazy(
  () => import("./views/Pages/Templates/BankStatements")
);
const TaxForms = React.lazy(() => import("./views/Pages/Templates/TaxForms"));

const Upgrade = React.lazy(
  () =>
    import("./views/Pages/Account/SelectPlanAfterTrial/SelectPlanAfterTrial")
);

const SupportLegacy = React.lazy(() => import("./views/Pages/Support/"));
const SupportLanding = React.lazy(
  () => import("./views/Pages/Support/SupportLanding")
);
const CustomerProfile = React.lazy(
  () => import("./views/Pages/Support/CustomerProfile")
);
const RefundInvestigator = React.lazy(
  () => import("./views/Pages/Support/RefundInvestigator")
);
const CreditsWorkflow = React.lazy(
  () => import("./views/Pages/Support/Workflow/CreditsWorkflow")
);
const AccessWorkflow = React.lazy(
  () => import("./views/Pages/Support/Workflow/AccessWorkflow")
);
const CancelWorkflow = React.lazy(
  () => import("./views/Pages/Support/Workflow/CancelWorkflow")
);
const SeatsWorkflow = React.lazy(
  () => import("./views/Pages/Support/Workflow/SeatsWorkflow")
);
const AdminAIChatReview = React.lazy(
  () => import("./views/Pages/Support/AIChatReview")
);
const AdminFAQManagement = React.lazy(
  () => import("./views/Pages/Support/FAQManagement")
);
const AdminGuardrailsManagement = React.lazy(
  () => import("./views/Pages/Support/GuardrailsManagement")
);
const Trials = React.lazy(
  () => import("./views/Pages/Support/TrialUsersTable")
);

const ChurnedUsers = React.lazy(
  () => import("./views/Pages/Support/ChurnedUsersTable")
);

const SwitchPlans = React.lazy(
  () => import("./views/Pages/Account/ChangePlan/SwitchPlans")
);

const CancelPlan = React.lazy(
  () => import("./views/Pages/Account/ChangePlan/CancelPlan")
);

const DocumentEditor = React.lazy(() => import("./views/Pages/DocumentEditor"));
const TemplateAddedColumns = React.lazy(
  () => import("./views/Pages/TemplateAddedColumns")
);

const Documents = React.lazy(() => import("./views/Pages/Documents"));

const WritePdf = React.lazy(() => import("./views/Pages/WritePdf"));
const QboApiDriver = React.lazy(() => import("./views/Pages/QboApiDriver"));

const Regions = React.lazy(
  () => import("./views/Pages/ExtractSingle/v2/Regions")
);

const Sandbox = React.lazy(() => import("./views/Pages/Sandbox"));
const SegmentSelection = React.lazy(() => import("./views/Pages/SegmentSelection/SegmentSelection"));
const ProspectCsv = React.lazy(() => import("./views/Pages/ProspectCsv"));

const GettingStarted = React.lazy(() => import("./views/Pages/GettingStarted"));

const DrawRectangleV3 = React.lazy(
  () => import("./views/Pages/ExtractSingle/v2/DrawRectangleV3")
);

const ExtractedDataViewer = React.lazy(
  () => import("./views/Pages/ExtractSingle/v2/ExtractedDataViewer")
);

// Simple test component with PDF viewer
const TestPDFViewer: React.FC = () => {
  return (
    <div style={{ padding: "20px" }}>
      {/* <h1>PDF Viewer Test</h1>
      <div
        style={{ marginBottom: "20px", padding: "10px", background: "#f0f0f0" }}
      >
        <h2>Debug Info</h2>
        <p>Component mounted successfully</p>
      </div> */}
      <div
        style={{ width: "800px", height: "600px", border: "1px solid #ccc" }}
      >
        <DrawRectangleV3Connected />
      </div>
    </div>
  );
};

// Add error boundary component
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error in component:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <pre>{this.state.error?.toString()}</pre>
        </div>
      );
    }

    return this.props.children;
  }
}

const routes = [
  { path: "/", exact: true, name: "Home" },
  {
    path: "/regions",
    exact: true,
    name: "regions",
    component: Regions,
    isProtected: false,
  },
  {
    path: "/pdf-test2",
    exact: true,
    name: "Extracted Data Viewer",
    component: ExtractedDataViewer,
    isProtected: false,
  },
  {
    path: "/pdf-test",
    exact: true,
    name: "PDF Test Viewer",
    component: TestPDFViewer,
    isProtected: false,
  },

  {
    path: "/templateEditor",
    exact: true,
    name: "Template Editor",
    component: DrawRectangleV3Connected,
    isProtected: false,
  },

  {
    path: "/viewOtherDocs",
    exact: true,
    name: "View Other Documents",
    component: ViewOtherDocuments,
    isProtected: false,
  },

  // DocuClipper
  {
    path: "/extract/single",
    exact: true,
    name: "Convert document",
    component: ExtractSingle,
  },
  {
    path: "/extract/template",
    exact: true,
    name: "Convert document using template",
    component: ExtractTemplate,
    docsUrl:
      "/docs/ui/user-guide/extracting-data/extracting-data-with-a-template/",
  },
  {
    path: "/extract/bankMode",
    exact: true,
    name: "Convert bank statements",
    component: ExtractBankMode,
    docsUrl: "",
  },
  {
    path: "/extract/invoice",
    exact: true,
    name: "Convert invoices & receipts",
    component: ExtractInvoice,
    docsUrl: "",
  },
  {
    path: "/extract/form",
    exact: true,
    name: "Convert form",
    component: ExtractForm,
    docsUrl: "",
  },
  {
    path: "/extractdata/*/template",
    exact: true,
    name: "",
    component: ExtractTemplate,
    docsUrl:
      "/docs/ui/user-guide/extracting-data/extracting-data-with-a-template/",
  },
  {
    path: "/dataArchive",
    exact: true,
    name: "Data Archive",
    component: ExtractDataJobs,
    docsUrl:
      "/docs/ui/user-guide/extracting-data/exploring-exporting-extracted-data/",
  },
  { path: "/extractdata", exact: true, name: "Convert Documents" },
  {
    path: "/extractdata/custom",
    exact: true,
    name: "Custom Document",
    component: CustomTemplates,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },
  {
    path: "/extract/csv2qbo",
    exact: true,
    name: "Convert CSV files",
    component: Csv2Qbo,
    docsUrl: "",
  },
  {
    path: "/extract/vendorscsv",
    exact: true,
    name: "Import Vendor Spreadsheet",
    component: VendorsCsv,
    docsUrl: "",
  },
  {
    path: "/select-segment",
    exact: true,
    name: "Select Segment",
    component: SegmentSelection,
    docsUrl: "",
    maxWidth: 1200,
  },
  // `/demo-entry` is mounted as an unprotected route in App.tsx (public demo landing
  // before login). Do not redeclare it here — it would shadow the unprotected one.
  {
    path: "/cf",
    exact: true,
    name: "cf",
    component: CustomFormat,
    docsUrl: "",
  },

  {
    path: "/extractdata/bankstatements",
    exact: true,
    name: "Bank & Credit Card Statements",
    component: BankStatements,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-bank-statements/",
  },
  {
    path: "/extractdata/taxforms",
    exact: true,
    name: "Forms (W-2, 1099, Paystubs, Tax Forms)",
    component: TaxForms,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-tax-forms/",
  },
  {
    path: "/customizableTemplates",
    exact: true,
    name: "Customizable Templates",
    component: CustomizableTemplates,
  },
  {
    path: "/mytemplates",
    exact: true,
    name: "My Templates",
    component: MyTemplates,
  },

  {
    path: "/manageIntegrations",
    exact: true,
    name: "Integrations",
    component: Integrations,
    docsUrl: "/docs/ui/user-guide/integrations/",
  },
  {
    path: "/pricing",
    exact: true,
    name: "Pricing",
    component: Pricing,
    isProtected: false,
    maxWidth: 1200,
  },
  {
    path: "/account",
    exact: true,
    name: "Account",
    component: Account,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/account/notifications",
    exact: true,
    name: "Notification settings",
    component: AccountNotifications,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/account/restartTrial",
    exact: true,
    name: "Restart your trial",
    component: RestartTrial,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/account/refer",
    exact: true,
    name: "Refer & Earn",
    component: ReferralProgram,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },

  // Legacy /account/invite is folded into /account/teams; route is now
  // rendered by the unified SeatManager so old bookmarks still resolve.
  {
    path: "/account/invite",
    exact: true,
    name: "Manage Users & Teams",
    component: SeatManager,
    docsUrl: "",
  },
  {
    path: "/account/teams",
    exact: true,
    name: "Manage Users & Teams",
    component: SeatManager,
    docsUrl: "",
  },

  {
    path: "/review",
    exact: true,
    name: "Review DocuClipper",
    component: AskForReview,
    docsUrl: "",
    maxWidth: 1200,
  },

  {
    path: "/review/intuit",
    exact: true,
    name: "QuickBooks App Store",
    component: ReviewIntuit,
    docsUrl: "",
    maxWidth: 1200,
  },

  {
    path: "/review/g2",
    exact: true,
    name: "G2",
    component: ReviewG2,
    docsUrl: "",
    maxWidth: 1200,
  },

  {
    path: "/jobData",
    exact: true,
    name: "Results",
    component: JobDataViewer,
    docsUrl:
      "/docs/ui/user-guide/extracting-data/exploring-exporting-extracted-data/",
  },
  {
    path: "/tl",
    exact: true,
    name: "Transations",
    component: TransactionManager,
    docsUrl: "",
  },
  {
    path: "/sandbox",
    exact: true,
    name: "Sandbox",
    component: Sandbox,
    docsUrl: "",
  },
  {
    path: "/template/new",
    exact: true,
    name: "New Custom Document",
    component: NewTemplate,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },
  {
    path: "/template/new2",
    exact: true,
    name: "New Custom Document",
    component: NewTemplate2,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },
  {
    path: "/template/invoice/new",
    exact: true,
    name: "New Custom Invoice",
    component: NewTemplate,
  },
  {
    path: "/template/bankStatement/new",
    exact: true,
    name: "New Custom Bank Statement",
    component: NewBankStatementTemplate,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },
  {
    path: "/template/tax/new",
    exact: true,
    name: "New Custom Tax Form",
    component: NewTaxTemplate,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },

  {
    path: "/template/update",
    exact: true,
    name: "Update Template",
    component: UpdateTemplate,
    docsUrl: "/docs/ui/user-guide/extracting-data/from-custom-documents/",
  },
  { path: "/extractdata", exact: true, name: "Extract Data", component: Tools },
  {
    path: "/extract/customDocument",
    exact: true,
    name: "Custom Document",
    component: CustomDocument,
  },

  {
    path: "/admin/users",
    exact: true,
    name: "Users",
    component: UsersTable,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/bull",
    exact: true,
    name: "BullMQ jobs",
    component: BullMqJobs,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/contracts",
    exact: true,
    name: "Manage contracts",
    component: Contracts,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/userexplorer",
    exact: true,
    name: "User Explorer",
    component: UserExplorer,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/documents",
    exact: true,
    name: "Document Explorer",
    component: AdminDocumentExplorer,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/pgboss",
    exact: true,
    name: "pg-boss jobs",
    component: PgbossJobs,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/badRatings",
    exact: true,
    name: "Bad Ratings",
    component: BadRatings,
    permission: "READ_DB_TABLES",
  },

  {
    path: "/admin/auditlog",
    exact: true,
    name: "Admin audit log",
    component: AuditLog,
    permission: "READ_DB_TABLES",
  },
  {
    path: "/admin/superlogin",
    exact: true,
    name: "Superlogin",
    component: Superlogin,
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/quickbooksaddnewcompany",
    exact: true,
    name: "Add QuickBooks company",
    component: QuickBooksAddNewCompany,
    docsUrl: "/docs/ui/user-guide/integrations/integration-quickbooks/",
  },
  {
    path: "/account/upgrade",
    exact: true,
    name: "Upgrade",
    component: Upgrade,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/support",
    exact: true,
    name: "Support",
    component: SupportLanding,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/legacy",
    exact: true,
    name: "Support (legacy)",
    component: SupportLegacy,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/c",
    exact: true,
    name: "Customer profile",
    component: CustomerProfile,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/refunds",
    exact: true,
    name: "Refund Investigator",
    component: RefundInvestigator,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/credits",
    exact: true,
    name: "Add credit",
    component: CreditsWorkflow,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/access",
    exact: true,
    name: "Account access",
    component: AccessWorkflow,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/cancel",
    exact: true,
    name: "Cancel & retain",
    component: CancelWorkflow,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/seats",
    exact: true,
    name: "Seats & contracts",
    component: SeatsWorkflow,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/admin/csm-config/ai-chat",
    exact: true,
    name: "AI Chat Review",
    component: AdminAIChatReview,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/admin/csm-config/faq",
    exact: true,
    name: "FAQ Management",
    component: AdminFAQManagement,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/admin/csm-config/guardrails",
    exact: true,
    name: "Guardrails",
    component: AdminGuardrailsManagement,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/trials",
    exact: true,
    name: "Trials",
    component: Trials,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/churned",
    exact: true,
    name: "Churned Users",
    component: ChurnedUsers,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  {
    path: "/support/prospectCsv",
    exact: true,
    name: "Upload Prospect CSV",
    component: ProspectCsv,
    docsUrl: "",
    permission: "SUPPORT_TOOL",
  },
  // {
  //   path: "/account/cards",
  //   exact: true,
  //   name: "Credit cards",
  //   component: UpdateCard,
  //   docsUrl: "/docs/ui/user-guide/managing-your-account/account/"
  // },
  {
    path: "/account/changePlans",
    exact: true,
    name: "Change plans",
    component: SwitchPlans,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/account/cancelPlan",
    exact: true,
    name: "Cancel plan",
    component: CancelPlan,
    docsUrl: "/docs/ui/user-guide/managing-your-account/account/",
    maxWidth: 1200,
  },
  {
    path: "/documentEditor",
    exact: true,
    name: "Format documents",
    component: DocumentEditor,
    docsUrl: "/docs/ui/user-guide/formatting-documents/formatting-documents/",
  },
  {
    path: "/templateAddedColumns",
    exact: true,
    name: "Added Columns",
    component: TemplateAddedColumns,
    docsUrl: "/docs/ui/user-guide/",
  },
  {
    path: "/documents",
    exact: true,
    name: "Documents",
    component: Documents,
    docsUrl: "",
  },
  {
    path: "/writePdf",
    exact: true,
    name: "Populate documents",
    component: WritePdf,
    docsUrl: "",
  },
  {
    path: "/qboApiDriver",
    exact: true,
    name: "QuickBooks API Driver",
    component: QboApiDriver,
    docsUrl: "",
  },
  {
    path: "/gettingStarted",
    exact: true,
    name: "Gettig Started",
    component: GettingStarted,
    docsUrl: "",
    maxWidth: 1200,
  },
  {
    path: "/invoices",
    exact: true,
    name: "Invoices",
    component: Invoices,
    docsUrl: "",
  },
  {
    path: "/invoices/approval-rules",
    exact: true,
    name: "Invoice Approval Rules",
    component: InvoiceApprovalRulesPage,
    docsUrl: "",
  },
  {
    path: "/forms",
    exact: true,
    name: "Forms",
    component: Forms,
    docsUrl: "",
  },
  {
    path: "/otherDocs",
    exact: true,
    name: "Other Documents",
    component: AutomaticDocs,
    docsUrl: "",
  },
  {
    path: "/templateDocs",
    exact: true,
    name: "Template Documents",
    component: TemplateDocs,
    docsUrl: "",
  },
  {
    path: "/invoiceViewer",
    exact: true,
    name: "Invoice",
    component: InvoiceViewer,
    docsUrl: "",
  },
  {
    path: "/transactions",
    exact: true,
    name: "Transactions",
    component: Transactions,
    docsUrl: "",
  },
  {
    path: "/fraud",
    exact: true,
    name: "Fraud Detection",
    component: FraudData,
    docsUrl: "",
  },
  {
    path: "/advancedAnalysis",
    exact: true,
    name: "Advanced Analysis",
    component: AnalyzeTabGated,
    docsUrl: "",
  },
  {
    path: "/onboarding",
    exact: true,
    name: "Onboarding",
    component: OnboardingWizard,
    docsUrl: "",
    maxWidth: 1200,
  },
  {
    path: "/assignJobsToProject",
    exact: true,
    name: "Assign Jobs",
    component: AssignJobsPage,
  },
  {
    path: "/webhooks",
    exact: true,
    name: "Webhooks",
    component: WebhooksPage,
    docsUrl: "",
  },

  {
    path: "/webhooks/:id/deliveries",
    exact: true,
    name: "Webhook Deliveries",
    component: WebhookDeliveries,
    docsUrl: "",
  },
  {
    path: "/organize",
    exact: true,
    name: "Organize Folders & Projects",
    component: React.lazy(() => import("./views/Pages/TagLevel/DragDropManager")),
    docsUrl: "",
  },
  {
    path: "/automations",
    exact: true,
    name: "Automations",
    component: React.lazy(() => import("./views/Pages/Automations")),
    docsUrl: "",
  },
  {
    path: "/forms",
    exact: true,
    name: "Forms",
    component: React.lazy(() => import("./views/Pages/Forms/FormsList")),
    docsUrl: "",
  },
  {
    path: "/forms/1099-summary",
    exact: true,
    name: "1099 Summary",
    component: React.lazy(() => import("./views/Pages/Forms/Form1099Summary")),
    docsUrl: "",
  },
];

export default routes;
